import { Component, OnInit } from '@angular/core';
import {ContentModel} from '../../Model/Content/content.model';
import {ContentService} from '../../Service/Content/content.service';
import {MenuDataService} from '../../Service/Common/menudata.service';
import { MenuModel } from '../../Model/Menu/menu.model';
import { Subscription } from 'rxjs/Subscription';
import {environment} from '../../../environments/environment';
import { RouterModule, Routes,ActivatedRoute,Router} from '@angular/router';
@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {
  contentData: ContentModel;
  selectedMenuItem:MenuModel;
  Customlist=[];
  id:number;
  private menuDataServiceSubscriptionRef: Subscription = null;
  constructor(private route:ActivatedRoute, private _ContentService: ContentService,private MenuDataService:MenuDataService) { 
    this.contentData=new ContentModel();
  }

  ngOnInit() 
  {

    this.menuDataServiceSubscriptionRef=this.MenuDataService.currentSelectedMenuItem.subscribe(selectedMenu=>{
     
      this.selectedMenuItem=selectedMenu;

     
      this.GetContent(this.selectedMenuItem.id) 
      this.GetSelectedForm(this.selectedMenuItem.id) 
      });
  }

  ngOnDestroy(){ 
    this.menuDataServiceSubscriptionRef.unsubscribe();
}

  loadContent(){
  }
  GetContent(id:number){
    
    this._ContentService.GetPageContent(id).subscribe(
      res =>{        
        if (res.isSuccess) {
          this.contentData=new ContentModel();
          this.contentData = res.responseData;
        
          if(this.contentData.headerImage!=null && this.contentData.headerImage!=''){
            this.contentData.headerImage=environment.server_url+'/images/contentimages/'+ this.contentData.headerImage;
          }else{

            this.contentData.headerImage='';
           
          }
          
        
        }else{
          return false;
        }
      }
    )
  }

  GetSelectedForm(id:number){
   this._ContentService.SelectedCustomForm(id).subscribe(
     res=>{       
       this.Customlist=res.responseData;
     }
   )   
 }
}
